import ApplicationV1Adapter from 'uplisting-frontend/adapters/application-v1';

export default class InvitationAdapter extends ApplicationV1Adapter {
  resend(id: string): Promise<object> {
    const url = `${this.buildURL('invitation', id)}/resend`;

    return this.ajax(url, 'POST') as Promise<object>;
  }
}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    invitation: InvitationAdapter;
  }
}
